import { render, staticRenderFns } from "./courseware.vue?vue&type=template&id=69cc5036&scoped=true&"
import script from "./courseware.vue?vue&type=script&lang=js&"
export * from "./courseware.vue?vue&type=script&lang=js&"
import style0 from "./courseware.vue?vue&type=style&index=0&id=69cc5036&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cc5036",
  null
  
)

export default component.exports